import { render, staticRenderFns } from "./CommonModalWithPurchaseRequestInfo.vue?vue&type=template&id=438fc3b2&lang=pug&"
import script from "./CommonModalWithPurchaseRequestInfo.vue?vue&type=script&lang=ts&"
export * from "./CommonModalWithPurchaseRequestInfo.vue?vue&type=script&lang=ts&"
import style0 from "./CommonModalWithPurchaseRequestInfo.vue?vue&type=style&index=0&id=438fc3b2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports